import React from "react";
import { Flex, Icon } from "discover.medical.react-component-library";
import {
  TocMenuButton,
  Header,
  SectionButtonsWrapper,
  TruncatedTitle,
} from "./_.styled";
import PreviousNextSection from "../../../components/PreviousNextSection";
import ContentBreadcrumb from "../../ContentBreadcrumb";
import { affordances } from "../../../util/analytics";

const FixedTopicHeader = ({
  handleTocItemClick,
  onBreadcrumbClick,
  previousAddress,
  nextAddress,
  previousHref,
  nextHref,
  isValidSplitContent,
  isMobile,
  isDesktop,
  activeSectionIndex,
  toc,
  openMobileToc,
  breadcrumbData,
  title,
  telemetryData,
  urlFragment,
  currentDmxDrugTab,
  history,
  handleDrugDetailNav,
  location,
  isDetailsTab,
}) => {
  const firstSectionReference = toc?.[0]?.reference;
  return (
    <Header data-testid="fixed-topic-header" className="bui-fixed">
      <Flex
        marginX="auto"
        container
        align={{ item: "center" }}
        paddingX="md"
        paddingY="sm"
      >
        {!isDesktop && (
          <>
            <TocMenuButton
              aria-label="topic menu"
              data-testid="mobile-toc-open-button"
              variant="quinary"
              kind="contained"
              size="iconOnly"
              onClick={openMobileToc}
              padded={false}
            >
              <Icon
                icon={{ glyph: "menu", size: "md" }}
                styles={{ margin: "0.1875rem" }}
              />
            </TocMenuButton>
            <TruncatedTitle>{title.label}</TruncatedTitle>
          </>
        )}

        {isDesktop && (
          <ContentBreadcrumb
            breadcrumbData={breadcrumbData}
            title={title}
            onBreadcrumbClick={onBreadcrumbClick}
            firstSectionReference={firstSectionReference}
            urlFragment={urlFragment}
            currentDmxDrugTab={currentDmxDrugTab}
          />
        )}

        {isValidSplitContent && (
          <SectionButtonsWrapper>
            <PreviousNextSection
              previousAddress={previousAddress}
              nextAddress={nextAddress}
              previousHref={previousHref}
              nextHref={nextHref}
              isMobile={isMobile}
              showText={!isMobile}
              telemetryData={{
                title: telemetryData?.title,
                affordance: affordances.HEADER,
              }}
              history={history}
              handleDrugDetailNav={handleDrugDetailNav}
              location={location}
              isDetailsTab={isDetailsTab}
            />
          </SectionButtonsWrapper>
        )}
      </Flex>
    </Header>
  );
};

FixedTopicHeader.displayName = "FixedTopicHeader";

export default FixedTopicHeader;
